






import { Vue, Prop, Component, Emit } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
  @Prop({ type: String, required: true, default: '' }) readonly label!: string;

  @Emit('clicked')
  clickedButton(): void {}
}
